import { Component, OnInit } from '@angular/core';
import { AdministrationSummaryService } from '../../services/administration/administration-summary.service';
import { httpOptions, serviceConstants } from '../../constants/service.constants';
import { CommonService } from 'src/app/services/common.service';
import { ModuleMenu } from 'src/app/models/common';
import { HeadService } from 'src/app/services/common/headservice';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-document-template',
  templateUrl: './document-template.component.html',
  styleUrls: ['./document-template.component.scss']
})
export class DocumentTemplateComponent implements OnInit {
  DocAttachList: any = [];
  menudata: ModuleMenu;
  moduleid: number;
  Application_ID:string="";
  SUB_MODULE: string;
  constructor(
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    private commonService: CommonService,
    private summaryService: AdministrationSummaryService,
    public headerService: HeadService
  ) { }

  ngOnInit() {
    //this.DocAttachList = [];
    let menudata = "";
    let module = this.headerService.getHeader().subscribe((result)=>{
      menudata=result.module;
      this.Application_ID = result.appId;
      this.GetDocTemplateData(menudata);
    });
    //this.GetDocTemplateData();
  }

  GetDocTemplateData(menudata: string) {
    this.DocAttachList = [];   

    if(menudata!=null)
    {
      if (menudata === "IST") { this.moduleid = 2;  this.SUB_MODULE = "IST"; this.Application_ID}
      else if (menudata === "GRANTSCME"){ this.moduleid = 4; this.SUB_MODULE = "CME"; this.Application_ID }
      else if (menudata === "GRANTSSPONSORSHIP"){ this.moduleid = 4; this.SUB_MODULE = "SPONSORSHIP"; this.Application_ID }
      else if (menudata === "GRANTSCHARITABLE"){ this.moduleid = 4; this.SUB_MODULE = "CHARITABLE"; this.Application_ID }
      else if (menudata === "EAP") { this.moduleid = 5;  this.SUB_MODULE = "EAP"; this.Application_ID}
    }



    this.summaryService.GetMasterScreenData('api/ISTDocumentAttachment/GetScreenTemplates?ModuleID=' + this.moduleid + "&SUB_MODULE=" + this.SUB_MODULE + "&ApplicationID=" +this.Application_ID).subscribe(summary => {
      this.DocAttachList = summary;
    });
  }
  downloadFile(fileID) {
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    window.open(Url);
  }
  ViewFile(fileID,fileName)
  {
    this.commonService.previewFile(fileID,fileName,"med");
  }
}
